import { NotFound } from 'src/containers/Errors/NotFound';
import { Login } from 'src/containers/Login/Login';
import { SignUp } from 'src/containers/SignUp/SignUp';
import { ConfirmEmail } from 'src/containers/ConfirmEmail/ConfirmEmail';
import { EmailConfirmed } from 'src/containers/ConfirmEmail/EmailConfirmed';
import { ForgotPassword } from 'src/containers/ForgotPassword/ForgotPassword';
import { EmailSent } from 'src/containers/ForgotPassword/EmailSent';
import { ForgotPasswordNewPassword } from 'src/containers/ForgotPassword/NewPassword';
import { Home } from 'src/containers/Home/Home';
import { ManageProfessionalData } from 'src/containers/ManageProfessionalData/ManageProfessionalData';
import { ManagePatient } from 'src/containers/ManagePatients/ManagePatient/ManagePatient';
import { CreatePartialPatient } from 'src/containers/CreatePartialPatient/CreatePartialPatient';
import { PrescriptionDetailsPage } from 'src/containers/History/PrescriptionDetails/PrescriptionDetails';
import { History } from 'src/containers/History/History';
import { TutorialPage } from 'src/containers/Tutorial/Tutorial';
import { HelpPage } from 'src/containers/Help/Help';
import { InviteAssistant } from 'src/containers/InviteAssistant/InviteAssistant';
import { AssistantSignUp } from 'src/containers/SignUp/AssistantSignUp/AssistantSignUp';
import { AssistantViewManagePatients } from 'src/containers/ManagePatients/AssistantViewManagePatients';
import { AssistantViewManageProfessionalData } from 'src/containers/ManageProfessionalData/Assistant/AssistantViewManageProfessionalData';
import { LambdaError } from 'src/containers/ConfirmEmail/LambdaError';
import { Onboarding } from 'src/containers/Onboarding';

const publicRoutes = [
  {
    path: '/',
    component: Login,
    index: true,
  },
  {
    path: '/entrar',
    component: Login,
  },
  {
    path: '/cadastro',
    component: SignUp,
  },
  {
    path: '/confirmaremail',
    component: ConfirmEmail,
  },
  {
    path: '/emailconfirmado',
    component: EmailConfirmed,
  },
  {
    path: '/lambda-error',
    component: LambdaError,
  },
  {
    path: '/esqueceu-sua-senha',
    component: ForgotPassword,
  },
  {
    path: '/esqueceu-sua-senha/email-enviado',
    component: EmailSent,
  },
  {
    path: '/esqueceu-sua-senha/nova-senha',
    component: ForgotPasswordNewPassword,
  },
  {
    path: '/assistente/cadastro',
    component: AssistantSignUp,
  },
];

const assistantProtectedRoutes = [
  {
    path: '/assistente/gerenciar-pacientes',
    component: AssistantViewManagePatients,
  },
  {
    path: '/assistente/meus-dados',
    component: AssistantViewManageProfessionalData,
  },
];

const doctorProtectedRoutes = [
  {
    path: '/inicio/receita',
    component: Home,
  },
  {
    path: '/inicio/meus-dados',
    component: ManageProfessionalData,
  },
  {
    path: '/inicio/historico',
    component: History,
  },
  {
    path: '/inicio/tutorial',
    component: TutorialPage,
  },
  {
    path: '/inicio/ajuda',
    component: HelpPage,
  },
  {
    path: '/inicio/convidar-assistente',
    component: InviteAssistant,
  },
];

const commomReturnableProtectedRoutes = [
  {
    path: '/inicio/cadastro-rapido-paciente',
    component: CreatePartialPatient,
  },
  {
    path: '/inicio/cadastro-completo-paciente',
    component: ManagePatient,
  },
  {
    path: '/inicio/editar-paciente/:patientId',
    component: ManagePatient,
  },
];

const doctorReturnableProtectedRoutes = [
  {
    path: '/inicio/historico/:historyId',
    component: PrescriptionDetailsPage,
  },
];

// Rotas de onboarding (sem FullLayout)
const onboardingRoutes = [
  {
    path: '/onboarding',
    component: Onboarding,
  },
];

const errorRoutes = [
  {
    path: '*',
    component: NotFound,
  },
];

const redirectRoutes = [
  {
    path: '/inicio/gerenciar-pacientes',
    redirectTo: '/inicio/receita',
  },
];

export {
  publicRoutes,
  doctorProtectedRoutes,
  errorRoutes,
  doctorReturnableProtectedRoutes,
  assistantProtectedRoutes,
  commomReturnableProtectedRoutes,
  redirectRoutes,
  onboardingRoutes,
};
